import React from 'react';
import { StudentOMRModel } from '../../../../models';
import { Calendar, Book, FileText, ChevronRight } from 'lucide-react';

interface OMRHistoryCardProps {
    result: StudentOMRModel;
    onView: () => void;
}

const OMRHistoryCard: React.FC<OMRHistoryCardProps> = ({ result, onView }) => {
    const formatDate = (ts: number) => {
        return new Date(ts).toLocaleDateString('ko-KR', {
            year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit'
        });
    };

    return (
        <button
            onClick={onView}
            className="group bg-white p-4 rounded-xl border border-slate-100 hover:border-indigo-200 text-left transition-all hover:shadow-md flex items-center justify-between gap-4 w-full"
        >
            <div className="flex items-center gap-4">
                <div className="w-12 h-12 shrink-0 rounded-xl bg-slate-50 border border-slate-100 flex items-center justify-center text-slate-400 group-hover:bg-indigo-600 group-hover:text-white group-hover:border-indigo-600 transition-all">
                    <Book size={22} />
                </div>
                <div className="min-w-0">
                    <div className="flex items-center gap-2 mb-1">
                        <span className="px-2 py-0.5 rounded bg-slate-100 text-[9px] font-bold text-slate-500 uppercase">{result.setTitle}</span>
                        {result.page !== undefined && (
                            <span className="px-2 py-0.5 rounded bg-indigo-50 text-[9px] font-black text-indigo-600 border border-indigo-100">
                                PDF {result.page}페이지
                            </span>
                        )}
                        <div className="flex items-center gap-1 text-[9px] font-medium text-slate-300">
                            <Calendar size={9} />
                            {formatDate(result.completedAt)}
                        </div>
                    </div>
                    <h4 className="text-sm font-bold text-slate-800 truncate mb-1">{result.bookTitle}</h4>
                    <div className="flex items-center gap-2">
                        <div className="flex items-center gap-1 text-xs font-medium text-slate-400">
                            <FileText size={11} className="text-slate-300" />
                            <span className="text-slate-600">{result.correctCount} / {result.totalCount}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div className="flex items-center gap-3">
                <div className="text-right">
                    <span className="block text-[9px] font-bold text-slate-300 uppercase mb-0.5">Score</span>
                    <span className={`text-xl font-black ${result.score >= 80 ? 'text-emerald-500' : result.score >= 60 ? 'text-amber-500' : 'text-rose-500'}`}>
                        {result.score}
                    </span>
                </div>
                <div className="w-8 h-8 rounded-lg bg-slate-50 flex items-center justify-center text-slate-300 group-hover:bg-indigo-50 group-hover:text-indigo-600 transition-all">
                    <ChevronRight size={18} />
                </div>
            </div>
        </button>
    );
};

export default OMRHistoryCard;
